import useJwt from '@/libs/auth/jwt/useJwt';
const axios = useJwt.axiosIns;

export const getFlexibilityIndex = () => axios.get('/api/');
export const getDeviceList = (params) => axios.get('/api/diagnosis/getDevice', { params });
export const getParams = (params) => axios.get('/api/diagnosis/getWriteData', { params });
export const createParams = (data) => axios.post('/api/diagnosis/mqtt/send', data);
export const getTemperature = (params) => axios.get('/api/diagnosis/hourly-ts', { params });
export const getIndoor = (params) => axios.get('/api/diagnosis/getCabremsorData/', { params });
export const getEnvironment = (params) => axios.get('/api/diagnosis/getppd', { params });
// export const getLoad = () => axios.get('/api/');
export const getControl = (params) => axios.get('/api/diagnosis/hourly-avg', { params });
export const getList = (params) => axios.get('/api/diagnosis/getList', { params });
// export const getOptimizing = () => axios.get('/api/');
